import React, { memo } from 'react';

import { Progress } from '@/components/ui/progressbar';

interface FreeShippingProgressProps {
    delayedPercentage: number;
    cart: any;
    freeShippingThresholdNumber: number;
}

const FreeShippingProgress: React.FC<FreeShippingProgressProps> = ({
    delayedPercentage: delayedPercentage1,
    cart,
    freeShippingThresholdNumber,
}) => (
    <>
        <div className="flex h-7 items-center justify-center text-center text-[.61rem] xxsm:text-xs">
            <div>
                You&apos;re <b>{cart?.OrderSummary?.AutoFreeShipAwayFromThreshold}</b> from{' '}
                <b>
                    FREE standard shipping on{' '}
                    <a
                        href="/pages/customer-service/shipping-handling"
                        target="_blank"
                        rel="noreferrer"
                        className="whitespace-nowrap !underline"
                    >
                        eligible items
                    </a>
                </b>
            </div>
        </div>
        <div className="mb-2.5 grid h-9 grid-cols-[auto_1fr_auto] gap-2 ">
            <div className="flex items-center justify-center">$0</div>
            <div className="flex items-center justify-center">
                <Progress value={delayedPercentage1} />
            </div>
            <div className="flex items-center justify-center">${freeShippingThresholdNumber}</div>
        </div>
    </>
);

export default memo(FreeShippingProgress);
